import rootReducer from "./reducers";
import { createStore } from "redux";
import { saveState, loadState, STORAGE_KEY } from "./local_storage";

// setup redux store
let store;
const persistedState = loadState();
if (process.env.NODE_ENV !== "production") {
  store = createStore(
    rootReducer,
    persistedState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
} else {
  store = createStore(rootReducer, persistedState);
}

store.subscribe(() => {
  const currentState = store.getState();
  // SAM-143: the refresh token is a long-lived bearer credential (up to a
  // day, see REFRESH_TOKEN_LIFETIME in
  // api/src/common/middleware/oauth2.middleware.ts) — an XSS reading it out
  // of localStorage would get long-lived session takeover instead of a
  // short window. It stays in the in-memory redux store for this tab's
  // session (nothing here reads it back out today; see the http.js TODO on
  // token refresh) but is stripped from what gets written to disk.
  const { refreshToken, refreshTokenExpiresAt, ...accessToken } =
    currentState.user.access_token || {};
  saveState({
    user: {
      ...currentState.user,
      access_token: accessToken,
    },
    shiftView: {
      ...currentState.shiftView,
      usersLoading: true,
      jobsLoading: true,
      users: [],
      jobs: [],
      userHover: null,
      rightPanelJob: null,
      rightPanelUser: null,
    },
    currentWidget: {
      ...currentState.currentWidget,
      widget: null,
    },
  });
});

// SAM-088: other tabs only wrote to localStorage, they never told this tab.
// The `storage` event fires in every *other* tab when one tab changes a
// localStorage key, so re-hydrate the user slice (login/logout/token
// refresh) from whatever the other tab just persisted.
window.addEventListener("storage", (event) => {
  if (event.key !== STORAGE_KEY) {
    return;
  }
  try {
    const newState = event.newValue ? JSON.parse(event.newValue) : undefined;
    store.dispatch({ type: "HYDRATE_USER", data: (newState && newState.user) || {} });
  } catch (e) {
    console.log("Failed to sync reduxState from another tab", e);
  }
});

export default store;
